import { Injectable } from "@angular/core";
import { ApplicationStatus } from "../enums/application-status.enum";
import { PermitType } from "../enums/permit-type.enum";
import { ApplicationStatusDescription } from "../enums/application-status-description.enum";
import { EvaluatorOffice } from "../enums/evaluator-office.enum";

@Injectable({
  providedIn: "root",
})
export class EnumService {
  constructor() { }

  getApplicationStatusEnum(): any {
    return ApplicationStatus;
  }

  getPermitType(): any {
    return PermitType;
  }

  getStatusDescrition(): any {
    return ApplicationStatusDescription;
  }

  getOfficeTypes(): any {
    return EvaluatorOffice;
  }

  getNotification(id) {
    switch (id) {
      case 1:
        return "This is to inform you that your application is now at HSO. To proceed with your application please be reminded of the following: For HSO stool processing: Submit a thumb-size stool sample and place it in a sterile, transparent, wide-mouth container or HSO provided container. Recycled containers will not be accepted Submit a sample within 2 hours of collection. If the sample is watery, submit within 30 mins. For HSO X-ray processing: No special preparation or requirement is needed for chest X-ray. Before the procedure, you’ll be asked to wear a hospital gown and remove all jewelries including body piercings and sunglasses. For RPR testing: No special preparation or requirement is needed for RPR. "
      case 2:
        return "This is to inform you that you may now proceed to HSO Room 105 for doctor’s evaluation. Bring original copies of your laboratory results"
      case 3:
        return "After reviewing your application, we have detected uncleared police record/s under your account. Please acquire court clearance at Municipal Trial Court at Justice Hall Building, Yandoc Street, Baguio City Benguet. Upon acquisition, you may proceed to BCPO and present the original copy. "
      case 4:
        return "After reviewing your application, we did not detect any uncleared police record/s under your account. You may proceed to BCPO for biometrics. Bring your original police clearance receipt. "
      case 5:
        return "Congratulations! This is to inform you that your application for Working Permit with Application No. APN-2023-002-273 under the name of Juan Dela Cruz has been approved. To claim your permit, you may proceed to PESO along with the original copies of the following: Working Permit Receipt Cedula Police Clearance Health Certificate Certificate of Attendance for Food Handlers "
      case 6:
        return "Your application is still pending for evaluation."

      default:
        break;
    }
  }
}
